import { Alert, Button, FileInput, Select, TextInput } from 'flowbite-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useNavigate } from 'react-router-dom';

export default function CreatePost() {
  const [file, setFile] = useState(null);
  const [imageUploadProgress, setImageUploadProgress] = useState(null);
  const [imageUploadError, setImageUploadError] = useState(null);
  const [formData, setFormData] = useState({});
  const [publishError, setPublishError] = useState(null);

  const navigate = useNavigate();

  const handleUpdloadImage = async () => {
    try {
      if (!file) {
        setImageUploadError('Please select an image');
        return;
      }
      setImageUploadError(null);
      
      const uploadFormData = new FormData();
      uploadFormData.append('file', file);
      
      setImageUploadProgress(50);
      
      const res = await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/upload/image`, {
        method: 'POST',
        body: uploadFormData,
        credentials: 'include',
      });
      
      const data = await res.json();
      
      if (!res.ok) {
        setImageUploadError(data.message || 'Image upload failed');
        setImageUploadProgress(null);
        return;
      }
      
      if (data.success) {
        setImageUploadProgress(null);
        setImageUploadError(null);
        setFormData({ ...formData, image: data.url });
      }
      
    } catch (error) {
      setImageUploadError('Image upload failed');
      setImageUploadProgress(null);
      console.log(error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Set default image if none uploaded
      const updatedFormData = {
        ...formData,
        image: formData.image || 'https://res.cloudinary.com/ddgkgaffw/image/upload/v1746758347/default-image_vxqxhk.png',
      };
      const res = await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/post/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(updatedFormData),
      });
      const data = await res.json();
      if (!res.ok) {
        setPublishError(data.message);
        return;
      }

      if (res.ok) {
        setPublishError(null);
        setFormData({}); // Clear form
        setFile(null); // Clear file
        navigate(`/post/${data.slug}`);
      }
    } catch (error) {
      setPublishError('Something went wrong');
    }
  };
  return (
    <div className='p-3 max-w-3xl mx-auto min-h-screen'>
      <h1 className='text-center text-3xl my-7 font-semibold'>Create a post</h1>
      <form className='flex flex-col gap-4' onSubmit={handleSubmit}>
        <div className='flex flex-col gap-4 sm:flex-row justify-between'>
          <TextInput
            type='text'
            placeholder='Title'
            required
            id='title'
            className='flex-1'
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
            value={formData.title || ''}
          />
          <Select
            onChange={(e) =>
              setFormData({ ...formData, category: e.target.value })
            }
            value={formData.category || ''}
          >
            <option value='uncategorized'>Select a category</option>
            <option value='java'>Java</option>
            <option value='spring'>Spring Boot</option>
            <option value='python'>Python</option>
            <option value='django'>Django</option>
            <option value='ai'>AI/ML</option>
            <option value='javascript'>JavaScript</option>
            <option value='react'>React</option>
            <option value='nextjs'>Next.js</option>
            <option value='angular'>Angular</option>
            <option value='databases'>Databases</option>
            <option value='devops'>DevOps</option>
            <option value='design_patterns'>Design Patterns</option>
            <option value='algorithms'>Data Structure & Algorithms</option>
            <option value="tech">Tech talk</option>
          </Select>
        </div>
        <div className='flex gap-4 items-center justify-between border-4 border-teal-500 border-dotted p-3'>
          <FileInput
            type='file'
            accept='image/*'
            onChange={(e) => setFile(e.target.files[0])}
          />
          <Button
            type='button'
            gradientDuoTone='purpleToBlue'
            size='sm'
            outline
            onClick={handleUpdloadImage}
            disabled={imageUploadProgress}
          >
            {imageUploadProgress ? (
              <div className='w-16 h-16'>
                <CircularProgressbar
                  value={imageUploadProgress}
                  text={`${imageUploadProgress || 0}%`}
                />
              </div>
            ) : (
              'Upload Image'
            )}
          </Button>
        </div>
        {imageUploadError && <Alert color='failure'>{imageUploadError}</Alert>}
        {formData.image && (
          <img
            src={formData.image}
            alt='upload'
            className='w-full h-72 object-cover'
          />
        )}
        <ReactQuill
          theme='snow'
          placeholder='Write here...'
          className='h-72 mb-12'
          required
          value={formData.content || ''}
          onChange={(value) => {
            setFormData({ ...formData, content: value });
          }}
        />
        <Button type='submit' gradientDuoTone='purpleToPink'>
          Publish
        </Button>
        {publishError && (
          <Alert className='mt-5' color='failure'>
            {publishError}
          </Alert>
        )}
      </form>
    </div>
  );
}